module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('input', {
    staticClass: "cb",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "id": _vm.cId
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.checked
    },
    on: {
      "click": _vm.select
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "icon-cb",
    attrs: {
      "for": _vm.cId
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9de017a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radio.vue
// module id = 867
// module chunks = 0